var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeviceSync = function SvgDeviceSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.518 3.982v.503h1.006v-.503A3.02 3.02 0 0 0 7.506.965h-.503V1.97h.503c1.11 0 2.012.902 2.012 2.011ZM3.482 10.018v-.503H2.477v.503a3.02 3.02 0 0 0 3.017 3.017h.503V12.03h-.503a2.014 2.014 0 0 1-2.012-2.011ZM4.991.965h-3.52C.915.965.465 1.415.465 1.97v5.532c0 .556.45 1.006 1.006 1.006h3.52c.556 0 1.006-.45 1.006-1.006V1.97c0-.555-.45-1.005-1.006-1.005Zm0 6.035h-3.52V2.473h3.52V7ZM11.53 5.491H8.009c-.556 0-1.006.45-1.006 1.006v5.532c0 .556.45 1.006 1.006 1.006h3.52c.556 0 1.006-.45 1.006-1.006V6.497c0-.556-.45-1.006-1.005-1.006Zm0 6.036H8.009V7h3.52v4.527Z",
    fill: "#000"
  })));
};
export default SvgDeviceSync;